import React from 'react';
import PropTypes from 'prop-types';
import { Card } from './Card';
import { RowItem } from './RowItem';
export const SingleRowCard = ({
  label,
  value
}) => {
  return React.createElement(Card, {
    wrapperAdditionalStyles: "margin: 5px 0;",
    padding: "20px 25px;"
  }, React.createElement(RowItem, {
    label: label,
    value: value
  }));
};
SingleRowCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired
};